<template lang="html">
<div class="pgInner affairEdit">

    <div class="headBar">新建政务</div>

    <div class="pgbody" :style="'height:' + pageH + 'px;'">
         <el-scrollbar ref="scroller" style="height:100%;">

           <div class="tabNavs" ref="tabNavs">
                <div v-for="(item,index) in navs" :key="index" @click="tabChange($event,index)" :class="['tabItem',{'act':navAct===index}]">
                     {{item}}
                </div>
                <div class="moveLine" :style="lineStr"></div>
           </div>

           <div class="tabContent">
                <Subpage1 @inited="readyHandle" :affid="postPms1.id" ref="subpage1" v-show="navAct===0" />
                <Subpage2 @inited="readyHandle" :affid="postPms1.id" ref="subpage2" v-show="navAct===1" />
                <Subpage3 @inited="readyHandle" :affid="postPms1.id" ref="subpage3" v-show="navAct===2" />
           </div>

         </el-scrollbar>
    </div>

    <div class="pagefoot">

      <div v-if="pgState" class="loading">
           <span v-if="pgState == 1">初始化中...</span>
           <span v-if="pgState == 2">数据保存中...</span>
           <i class="el-icon-loading"></i>
      </div>
      <div v-else>
           <el-button @click="directSave(1)" type="primary" size="small">立即发布</el-button>
           <!-- <el-button @click="ansSave" type="primary" size="small">发布并新建解读</el-button> -->
           <el-button @click="directSave(2)" plain size="small">存为草稿</el-button>
           <el-button @click="goReturn" plain size="small">取消</el-button>
      </div>

    </div>

    <unsModel @goCreate="goCreate" ref="unsPop" />

</div>
</template>

<script>
import { affSave,affLocs,affConditions,addHandles,affPgress,affFiles,getAffair } from "@/api/affairs/affairs";
import Subpage1 from "./src/Subpage1";
import Subpage2 from "./src/Subpage2";
import Subpage3 from "./src/Subpage3";
import unsModel from "./src/unsModel";


export default {
    components:{
        Subpage1,
        Subpage2,
        Subpage3,
        unsModel
    },
    computed:{
        lineStr:function(){
            var str = 'width:60px;';
            str = str + "left:" + this.navX + "px;";
            return str;
        },
        pgState:function(){
            var state = 0;
            if(this.id && this.readyKey !== 3){
                state = 1;
            }

            if(this.uploadIng){
                state = 2;
            }

            return state;
        }
    },
    data(){
        return{

            id:'',
            navs:['基本信息','办理流程','申请材料'],
            navAct:0,
            navX:15,
            pageH:'',
            readyKey:0,
            uploadIng:false,

            postPms1:{
                id:''
            },

            postPms2:{
                cqjZhengwuHandleMattersId:''
            }

        }
    },

    methods:{
        goReturn:function(){
            this.$router.go(-1);
        },
        tabChange:function(e,inx){

            var tabNavs = this.$refs.tabNavs;
            this.navAct = inx;
            this.navX = e.target.offsetLeft;

        },
        pageFix:function(){
            this.pageH = document.documentElement.clientHeight - 205;
        },
        prevSet:function(){

            var vues = this;
            var querys = this.$route.query;

            // 底部定位
            this.pageFix();

            // 获取初始 ID
            if(querys.id){
                vues.id = querys.id;
                vues.postPms1.id = querys.id;
                vues.postPms2.cqjZhengwuHandleMattersId = querys.id;

                getAffair({id:querys.id}).then(res => {
                    console.log(res);
                    vues.$refs.subpage1.preEdit(res);
                    vues.$refs.subpage2.preEdit(res);
                    vues.$refs.subpage3.preEdit(res);
                })

            }else{
                affSave().then(res => {
                    vues.postPms1.id = res.handleMatters.id;
                    vues.postPms2.cqjZhengwuHandleMattersId = res.handleMatters.id;
                }).catch(err => {});
            }

        },

        readyHandle:function(){
            this.readyKey++;
        },

        ansSave:function(type){
            this.$refs.unsPop.openstate = true;
        },

        goCreate:function(e){
           this.directSave(1,e)
        },

        directSave:function(status){
            var vues = this;
            var wait = this.$refs.subpage1.saveReturn();

            function goSave(res){
                var pms1 = res[0];
                var pms2 = vues.$refs.subpage2.saveReturn();
                var pms3 = vues.$refs.subpage3.saveReturn();
                var pms4 = res[1];
                var pms5 = res[2];
                var pms6 = res[3];

                if(!pms1){
                    vues.$message.error('基本信息未填写完成！');
                }else if(!pms2){
                    vues.$message.error('办理流程未填写完成！');
                }else if(pms3.length == 0){
                    vues.$message.error('申请材料未填写完成！');
                }else if(pms4.length == 0){
                    vues.$message.error('办理地点不能为空！');
                }else if(pms5.length == 0){
                    vues.$message.error('受理条件不能为空！');
                }else if(pms6.length == 0){
                    vues.$message.error('办理条件不能为空！');
                }else{
                    var promiseArr = [];

                    vues.uploadIng = true;

                    promiseArr.push(new Promise((resolve,reject) => {    // 基本信息
                        var pms = $.extend({},vues.postPms1,pms1);
                        pms.status = status;
                        affSave({handleMatters:pms}).then(res => {
                            resolve(res);
                        }).catch(err => {
                            reject(err);
                        })
                    }))

                    promiseArr.push(new Promise((resolve,reject) => {    //  办理流程
                        var pms = $.extend({},vues.postPms2,pms2);
                        pms.status = status;
                        affPgress(pms).then(res => {
                            resolve(res);
                        }).catch(err => {
                            reject(err);
                        })
                    }))

                    promiseArr.push(new Promise((resolve,reject) => {    //  申请材料
                        var pms = $.extend({},vues.postPms2,{applicationMaterialsList:pms3});
                        pms.status = status;
                        affFiles(pms).then(res => {
                            resolve(res);
                        }).catch(err => {
                            reject(err);
                        })
                    }))

                    promiseArr.push(new Promise((resolve,reject) => {   //  办理地点
                        var pms = $.extend({},vues.postPms2,{handleAddressList:pms4});
                        pms.status = status;
                        affLocs(pms).then(res => {
                            resolve(res);
                        }).catch(err => {
                            reject(err);
                        })
                    }))

                    promiseArr.push(new Promise((resolve,reject) => {   //  受理条件
                        var pms = $.extend({},vues.postPms2,{acceptanceConditionsList:pms5});
                        pms.status = status;
                        affConditions(pms).then(res => {
                            resolve(res);
                        }).catch(err => {
                            reject(err);
                        })
                    }))

                    promiseArr.push(new Promise((resolve,reject) => {   //  办理条件
                        var pms = $.extend({},vues.postPms2,{processConditionsList:pms6});
                        pms.status = status;
                        addHandles(pms).then(res => {
                            resolve(res);
                        }).catch(err => {
                            reject(err);
                        })
                    }))

                    Promise.all(promiseArr).then(res => {
                        vues.uploadIng = false;
                        vues.$router.push('affairs');
                    })

                }
            }

            wait.then(res => {
                goSave(res);
            })
        }

    },
    created:function(){
        var vues = this;
        var querys = this.$route.query;

        this.prevSet();
        $(window).resize(function(){
    		     vues.pageFix();
             vues.$refs.scroller.$data.sizeHeight = this.pageH;
    	  })

        this.readyKey = 3;

    }


}
</script>

<style lang="scss" scoped>

.pgInner{
  background: #f5f5f5;
}

.headBar{
  height: 55px;
  line-height: 55px;
  font-size: 16px;
  padding-left: 20px;
  background: white;
}

.tabNavs{
  height: 50px;
  padding-left: 15px;
  background: white;
  position: relative;
  .tabItem{
     float: left;
     height: 50px;
     line-height: 50px;
     font-size: 15px;
     margin-right: 45px;
     cursor: pointer;
  }
  .tabItem.act{
    color: rgb(86, 119, 252);
  }
  .moveLine{
    height: 2px;
    background: rgb(86, 119, 252);
    position: absolute;
    bottom: 0px;

    transition-property: all;
    transition-duration: 0.2s;
  }
}

.tabContent{
  padding: 20px;
  background: white;
}

.pagefoot{
  height: 60px;
  line-height: 60px;
  background: white;
  padding-left: 20px;
  position: relative;
  z-index: 2;
  .btn{
    height: 32px;
    padding: 0 12px;
    margin-right: 12px;
    display: inline-block;
    font-size: 14px;
    cursor: pointer;
  }
  .type1{
    line-height: 32px;
    background: rgb(86, 119, 252);
    color: white;
  }
  .type2{
    box-sizing: border-box;
    border: 1px solid #aeaeae;
    line-height: 30px;
  }

  .loading{
     font-size: 14px;
     padding-left: 24px;
     color: #AEAEAE;
     i{
         font-size: 18px;
         vertical-align: middle;
     }
  }
}

</style>

<style lang="css">

.affairEdit .pgbody{
  margin: 20px;
}


@media only screen and (max-width: 1366px) {
    .affairEdit .pgbody{
        margin: 10px 0;
    }
}

</style>



// WEBPACK FOOTER //
// affairEdit.vue?5b9ea627